"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.navigateLink = exports.isGatsbyLink = exports.checkMenuItemPermission = exports.getUrl = void 0;

var common_permissions_1 = require("@ryerson/common.permissions");

var Menu_models_1 = require("./Menus/Menu.models");

var Constants_1 = require("./Constants");

var gatsby_link_1 = require("gatsby-link");

var common_permissions_2 = require("@ryerson/common.permissions");

var getUrl = function getUrl(url) {
  var externalUrl = url;

  if (typeof window !== "undefined") {
    externalUrl = window.location.origin + url;
  }

  return externalUrl;
};

exports.getUrl = getUrl; // CheckPermission

var checkMenuItemPermission = function checkMenuItemPermission(id) {
  var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var UserPermissionUtil = new common_permissions_1.UserPermission(token);

  if (UserPermissionUtil.decodedToken.account === "99") {
    switch (id) {
      case Menu_models_1.AccountMenuItemId.accountSettings:
      case Menu_models_1.AccountMenuItemId.adminPortal:
      case Menu_models_1.AccountMenuItemId.logOut:
        return true;

      default:
        return false;
    }
  }

  if (common_permissions_2.Mode[UserPermissionUtil.getUserMode()] === common_permissions_2.Mode.normal) {
    if (UserPermissionUtil.decodedToken.roles.includes("Super Store Administrator") || UserPermissionUtil.decodedToken.roles.includes("Store Administrator")) {
      if (id === Menu_models_1.AccountMenuItemId.quotes || id === Menu_models_1.AccountMenuItemId.orders) {
        return false;
      }
    }
  }

  switch (id) {
    case Menu_models_1.AccountMenuItemId.accountSettings:
      return UserPermissionUtil.has(common_permissions_1.Permission.Account_Settings);

    case Menu_models_1.AccountMenuItemId.adminPortal:
      return UserPermissionUtil.has(common_permissions_1.Permission.Admin_Portal_Magenium);

    case Menu_models_1.AccountMenuItemId.dashboard:
      return UserPermissionUtil.has(common_permissions_1.Permission.Customer_Dashboard_View_Edit);

    case Menu_models_1.AccountMenuItemId.documentCenter:
      return UserPermissionUtil.has(common_permissions_1.Permission.Document_Menu_View_Edit);

    case Menu_models_1.AccountMenuItemId.orders:
      return UserPermissionUtil.has(common_permissions_1.Permission.Orders_View);

    case Menu_models_1.AccountMenuItemId.quotes:
      return UserPermissionUtil.has(common_permissions_1.Permission.Quotes_View_Edit);

    case Menu_models_1.AccountMenuItemId.reports:
      return UserPermissionUtil.has(common_permissions_1.Permission.Reports_Store_Admin);

    case Menu_models_1.AccountMenuItemId.shoppingList:
      return UserPermissionUtil.has(common_permissions_1.Permission.Shopping_List_View_Edit);

    case Menu_models_1.AccountMenuItemId.subscribeSave:
      return UserPermissionUtil.has(common_permissions_1.Permission.Subscribe_Save_View);

    case Menu_models_1.AccountMenuItemId.userManagement:
      return UserPermissionUtil.has(common_permissions_1.Permission.User_Management_View);

    case Menu_models_1.AccountMenuItemId.invoices:
      return UserPermissionUtil.has(common_permissions_1.Permission.Invoice_View_Pay);

    case Menu_models_1.AccountMenuItemId.exitShadowMode:
      return common_permissions_2.Mode[UserPermissionUtil.getUserMode()] !== common_permissions_2.Mode.normal;

    default:
      return true;
  }
};

exports.checkMenuItemPermission = checkMenuItemPermission;

var isGatsbyLink = function isGatsbyLink(isStoreLink, storeDirectory) {
  var isStoreApp = storeDirectory !== Constants_1.STORE;
  return isStoreApp === isStoreLink;
};

exports.isGatsbyLink = isGatsbyLink;

var navigateLink = function navigateLink(storeDirectory, url) {
  var isStoreApp = storeDirectory !== Constants_1.STORE;
  /* eslint-disable no-useless-escape */

  var newUrl = url.replace(/^\/?([^\/]+(?:\/[^\/]+)*)\/?$/, "/$1/") || "/";

  if (isStoreApp) {
    return (0, gatsby_link_1.navigate)(newUrl);
  } else {
    window.location.href = storeDirectory + newUrl;
  }
};

exports.navigateLink = navigateLink;